import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// servicios
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

// interfaces
import { IApiResp } from 'src/app/interfaces/api-resp'; 
import { IUsuario } from 'src/app/interfaces/usuario';

// librerías y pipes 
import Swal from 'sweetalert2';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-psw-reset',
  templateUrl: './psw-reset.component.html',
  styleUrls: ['./psw-reset.component.scss']
})
export class PswResetComponent implements OnInit {

  resetMd5 = '';
  public usuario: IUsuario = {};

  loading: boolean = false;
  public enviado: boolean = false;
  public imposible: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public usrSrv: UsuarioService,
    private notifSrv: NotificacionesService,
  ) { }

  public pswForm = this.fb.group({
    password: ['', Validators.required],
    password2: ['', Validators.required]
  })

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.resetMd5 = params.get('md5') || '';
      console.log('__md5:', this.resetMd5);

      this.getUserByRestore()

    });
  }


  // Método para obtener el usuario por el md5
  getUserByRestore() {
    this.usrSrv.getUserByRestore(this.resetMd5).subscribe((resp: IApiResp) => {
      console.log('__getUserByRestore() resp:', resp);
      if (resp.error) {
        this.imposible = true;
        this.notifSrv.aviso('error', 'Error al intentar recuperar la contraseña, el hash no es correcto o está caducado.');

        Swal.fire({
          title: 'Código incorrecto',
          text: 'El código de restauración no es correcto o ha caducado. Si necesitas ayuda, contacta con el administrador del sistema.',
          icon: 'error'
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.close();
          }
        })
        // this.cancelar();
        return;
      }
      if (resp.data) {
        this.notifSrv.aviso('success', 'El código de restauración es correcto, puedes cambiar la contraseña.');
        this.usuario = resp.data.user;
      }

    });
  }
  // Envío del form  
  enviar() {
    this.enviado = true;

    if (this.pswForm.invalid) {
      console.log("ERRORES en pswForm:", this.pswForm);
      return;
    }

    // Todo ok, enviar al BackEnd
    this.loading = true;
    const data = {
      password: this.pswForm.get('password')?.value,
      password2: this.pswForm.get('password2')?.value,
      restore: this.resetMd5
    }
    console.log('data:', data);
    this.usrSrv.pswChange(data)
      .subscribe(resp => {
        this.loading = false;
        console.log('resp:', resp);
        if (resp.error) {
          // this.notificacionesService.aviso('error', resp.mensaje);
          console.log(resp.mensaje);
          for (let controlName in resp.mensaje) {
            if (controlName !== 'password2') {
              this.notifSrv.aviso('error', resp.mensaje);
            } else {
              this.pswForm.get(controlName)!.setErrors({ 'apiError': resp.mensaje[controlName] });
            }
          }
        } else {
          this.notifSrv.aviso('success', `Contraseña cambiada correctamente para el usuario <b>${this.usuario.nombre}</b>`);
          Swal.fire({
            title: 'Contraseña cambiada',
            html: `Contraseña cambiada correctamente para el usuario <b>${this.usuario.username}</b>`,
            icon: 'success'
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.close();
            }
          })
          // this.pswForm.reset();
          // this.enviado = false;
          // this.router.navigateByUrl(`login`);
          // window.close();
        }
      })
  }


  cancelar() {
    this.pswForm.reset();
    this.notifSrv.aviso('info', 'Cambio de contraseña cancelado');
    // this.router.navigateByUrl(`login`);
    window.close();
  }

  //  AUX  //


  get f() {
    return this.pswForm.controls;
  }

}

